import { useState } from "react";
import Button from "../../../../components/ui/Button";
import Card, { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../../components/ui/Card";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../../../../components/ui/Modal";
import Table, { TBody, TFoot, THead, Td, Th, Tr } from "../../../../components/ui/Table";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import Icon from "../../../../components/icon/Icon";
import TableSkeletonLoader from "../../../../components/loader/skeleton/tableSkeletonLoader";

const SelectAdvertisementImage = ({ modalStatus, setModalStatus, AssetId, images, setImages }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [addAddLoader, setAddAddLoader] = useState(false);
  const [sorting, setSorting] = useState([]);

  const [tempImg, setTempImg] = useState(images);
  const columnHelper = createColumnHelper();

  const handleAllSelect = () => {
    if (tempImg?.length > 0) {
      let newImgList = [];
      if (tempImg?.filter((item) => item.AddedToAdvertisement).length === tempImg?.length) {
        tempImg.map((items) => {
          newImgList.push({
            ...items,
            AddedToAdvertisement: false,
          });
        });
        setTempImg(newImgList);
      } else {
        tempImg.map((items) => {
          newImgList.push({
            ...items,
            AddedToAdvertisement: true,
          });
        });
        setTempImg(newImgList);
      }
    }
  };

  const handleCheckboxChange = (rowIndex) => {
    setTempImg((prevImages) =>
      prevImages.map((img, index) =>
        index === rowIndex ? { ...img, AddedToAdvertisement: !img.AddedToAdvertisement } : img
      )
    );
  };

  const columns = [
    {
      id: "select-col",
      header: ({ table }) => (
        <input
          type="checkbox"
          className="mr-2  text-[#161412]"
          name="Featured"
          checked={
            tempImg?.length > 0
              ? tempImg?.filter((item) => item.AddedToAdvertisement).length === tempImg?.length
              : false
          }
          onChange={() => handleAllSelect()}
        />
      ),
      cell: ({ row }) => (
        <input
          type="checkbox"
          className="mr-2  text-[#161412]"
          name="Featured"
          checked={row?.original?.AddedToAdvertisement}
          onChange={() => handleCheckboxChange(row.index)}
          disabled={AssetId ? row?.original?.Main : row.index === 0}
        />
      ),
    },
    columnHelper.accessor("AssetPictureUrl", {
      cell: (info) => (
        <div className="flex items-center justify-center">
          <img
            className="aspect-[9/12] w-[60px] h-[60px] rounded object-cover 2xl:w-[150px] 2xl:h-[150px]"
            src={info?.row?.original?.preview}
            alt=""
          />
        </div>
      ),
      header: "Image",
      footer: "Image",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Picture Name", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.FileName || "-"}</div>,
      header: "Picture Name",
      footer: "Picture Name",
    }),

    columnHelper.accessor("Main", {
      cell: (info) => (
        <div
          className={`text-sm text-center text-[${
            AssetId
              ? info?.row?.original?.Main
                ? "#00BE5F"
                : "#FE2B06"
              : info?.row.index === 0
              ? "#00BE5F"
              : "#FE2B06"
          }]`}
        >
          {AssetId ? (info?.row?.original?.Main ? "Yes" : "No") : info?.row.index === 0 ? "Yes" : "No"}
        </div>
      ),
      header: "Main",
      footer: "Main",
    }),
  ];

  const table = useReactTable({
    data: tempImg,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    // debugTable: true,
  });

  const handleSave = () => {
    setModalStatus(false);
    setImages(tempImg);
  };

  return (
    <>
      <Modal
        isOpen={modalStatus}
        setIsOpen={setModalStatus}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"lg"}
      >
        <ModalHeader>Select Advertisements Image</ModalHeader>
        <ModalBody>
          {isLoading || addAddLoader ? (
            <div className="fixed w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0  right-0">
              <span class="loader"></span>
            </div>
          ) : null}
          <Card>
            <CardBody>
              <Table className="table-fixed max-md:min-w-[70rem]">
                <THead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <Tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <Th key={header?.id} isColumnBorder={false} className="text-left">
                          {header?.isPlaceholder ? null : (
                            <div
                              key={header.id}
                              aria-hidden="true"
                              {...{
                                className: header.column.getCanSort()
                                  ? "cursor-pointer select-none flex items-center justify-center  text-center"
                                  : "",
                                onClick: header.column.getToggleSortingHandler(),
                              }}
                            >
                              {flexRender(header.column.columnDef.header, header.getContext())}
                              {{
                                asc: <Icon icon="HeroChevronUp" className="ltr:ml-1.5 rtl:mr-1.5" />,
                                desc: <Icon icon="HeroChevronDown" className="ltr:ml-1.5 rtl:mr-1.5" />,
                              }[header.column.getIsSorted()] ?? null}
                            </div>
                          )}
                        </Th>
                      ))}
                    </Tr>
                  ))}
                </THead>
                <TBody>
                  {!isLoading ? (
                    Number(tempImg.length) <= 0 ? (
                      <Tr>
                        <Td className="text-center py-[100px] font-normal text-[30px]" colspan="4">
                          No Record Found
                        </Td>
                      </Tr>
                    ) : (
                      table.getRowModel().rows.map((row) => (
                        <Tr key={row.id}>
                          {row.getVisibleCells().map((cell) => (
                            <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
                          ))}
                        </Tr>
                      ))
                    )
                  ) : (
                    [...Array(5)].map((_, index) => (
                      <Tr className="bg-gray-100">
                        <TableSkeletonLoader length={11} />
                      </Tr>
                    ))
                  )}
                </TBody>
              </Table>
            </CardBody>
          </Card>
        </ModalBody>

        <ModalFooter className="mt-[20px]">
          <ModalFooterChild></ModalFooterChild>
          <ModalFooterChild>
            <Button
              onClick={() => setModalStatus(false)}
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#cb3b41]"
            >
              Close
            </Button>
            <Button
              onClick={() => handleSave()}
              className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
            >
              Save
            </Button>
          </ModalFooterChild>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default SelectAdvertisementImage;
